export default {
  state: {
    isLoading: false,
    navigationOpen: false,
    recipients: []
  },
  mutations: {
    startLoading(state) {
      state.isLoading = true
    },
    stopLoading(state) {
      state.isLoading = false
    },
    openNavigation(state) {
      state.navigationOpen = true
    },
    closeNavigation(state) {
      state.navigationOpen = false
    },
    initialiseRecipients(state, { items }) {
      state.recipients = items
    },
  }
}